(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAsignacionDeleteController',SSAsignacionDeleteController);

    SSAsignacionDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSAsignacion'];

    function SSAsignacionDeleteController($uibModalInstance, entity, SSAsignacion) {
        var vm = this;

        vm.sSAsignacion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSAsignacion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
